import './App.css';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import LoadingPage from './pages/LoadingPage';
import WelcomePage from './pages/WelcomePage';
import HomePage from './pages/HomePage';


function App() {
  return (
    <Router >
      <Routes>
        <Route path='' Component={LoadingPage}/>
        <Route path='/welcome' Component={WelcomePage}/>
        <Route path='/home' Component={HomePage}/>
      </Routes>
    </Router>
  );
}

export default App;
